<div mat-dialog-title>
  <app-dialog-close-cross></app-dialog-close-cross>
  <h2 id="RecipesModifyCopyTitleLbl">{{ 'COPY_RECIPES.MODAL.TITLE' | translate }}</h2>
</div>

<div mat-dialog-content class="min-content">
  <form [formGroup]="formCopy">
    <div class="row row-horizontal">
      <mat-card class="form-card">
        <mat-card-header class="form-card-header">
          {{ 'COPY_RECIPES_MARKET.MODAL.SOURCE' | translate }}
        </mat-card-header>
        <mat-card-content class="form-card-content">
          <mat-form-field class="mat-form-field" appearance="fill">
            <mat-label>{{ 'DOMAIN' | translate }}</mat-label>
            <mat-select id="RecipesModifyCopySourceDomainLbl" formControlName="sourceDomain" required>
              <mat-option *ngFor="let current of domains | sortBy : 'translatedName'" [value]="current.key">
                <span> {{ current.translatedName }}</span>
              </mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field class="mat-form-field" appearance="fill">
            <mat-label>{{ 'MARKET' | translate }}</mat-label>
            <mat-select formControlName="sourceMarket" id="RecipesModifyCopySourceMarketLbl" required>
              <mat-option [value]="sourceMarket.key">
                {{ sourceMarket.translatedName }}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field class="mat-form-field" appearance="fill">
            <mat-label>{{ 'LANG' | translate }}</mat-label>
            <mat-select formControlName="sourceLang" id="RecipesModifyCopySourceLangBtn" required>
              <div id="RecipesModifyCopySourceLangLst">
                <mat-option *ngFor="let current of languagesFilteredSources | sortBy : 'translatedName' : 'ASC'" [value]="current.key">
                  {{ current.translatedName }}
                </mat-option>
              </div>
            </mat-select>
          </mat-form-field>

          <mat-form-field class="mat-form-field" appearance="fill">
            <mat-label>{{ 'TITLE' | translate }}</mat-label>
            <input matInput formControlName="sourceTitle" id="RecipesModifyCopySourceTitleLbl" aria-disabled="true" required />
            <mat-error *ngIf="formCopy.controls.sourceTitle.hasError('required')"> {{ 'TITLE_REQUIRED' | translate }} </mat-error>
          </mat-form-field>

          <div class="mat-form-field">
            <mat-label>{{ 'VARIANTS.LABEL' | translate }}</mat-label>
            <br />
            <div id="RecipesModifyCopySourceVariantLst">
              <span *ngFor="let variant of variantList; let last = last">
                {{ variant.lang }}: {{ variant.yield.quantity }}<span *ngIf="!last">, </span>
              </span>
            </div>
          </div>
        </mat-card-content>
      </mat-card>

      <mat-card class="form-card">
        <mat-card-header class="form-card-header">
          {{ 'COPY_RECIPES_MARKET.MODAL.TARGET' | translate }}
        </mat-card-header>
        <mat-card-content class="form-card-content">
          <mat-form-field class="mat-form-field" appearance="fill">
            <mat-label>{{ 'DOMAIN' | translate }}</mat-label>
            <mat-select
              formControlName="targetDomain"
              id="RecipesModifyCopyTargetDomainBtn"
              (selectionChange)="updateDomain($event.value)"
              required
            >
              <div id="RecipesModifyCopyTargetDomainLst">
                <mat-option *ngFor="let current of domains | sortBy : 'translatedName'" [value]="current.key">
                  {{ current.translatedName }}
                </mat-option>
              </div>
            </mat-select>
          </mat-form-field>

          <mat-form-field class="mat-form-field" appearance="fill">
            <mat-label>{{ 'MARKET' | translate }}</mat-label>
            <mat-select
              formControlName="targetMarket"
              id="RecipesModifyCopyTargetMarketBtn"
              (selectionChange)="updateLang($event.value, false)"
              required
            >
              <div id="RecipesModifyCopyTargetMarketLst">
                <mat-option *ngFor="let current of markets | sortBy : 'translatedName' : 'ASC'" [value]="current.key">
                  {{ current.translatedName }}
                </mat-option>
              </div>
            </mat-select>
          </mat-form-field>

          <mat-form-field class="mat-form-field" appearance="fill">
            <mat-label>{{ 'LANG' | translate }}</mat-label>
            <mat-select formControlName="targetLang" id="RecipesModifyCopyTargetLangBtn" required>
              <div id="RecipesModifyCopyTargetLangLst">
                <mat-option *ngFor="let current of languagesFilteredTarget | sortBy : 'translatedName' : 'ASC'" [value]="current.key">
                  {{ current.translatedName }}
                </mat-option>
              </div>
            </mat-select>
          </mat-form-field>

          <mat-form-field class="mat-form-field" appearance="fill">
            <mat-label>{{ 'TITLE' | translate }}</mat-label>
            <input matInput formControlName="targetTitle" required />
            <mat-error *ngIf="formCopy.controls.targetTitle.hasError('required')"> {{ 'TITLE_REQUIRED' | translate }} </mat-error>
            <mat-error *ngIf="formCopy.controls.targetTitle.hasError('binerator')">
              {{ 'BINERATOR.RULES.TITLE.TOO_LONG' | translate }}
            </mat-error>
          </mat-form-field>
        </mat-card-content>
      </mat-card>
    </div>
    <div *ngIf="isAuthorizeSynchro">
      <mat-checkbox class="space-h-s" id="RecipesModifyCopySynchroChkBox" formControlName="synchro">{{
        'COPY_RECIPES.MODAL.SYNC_VAR' | translate
      }}</mat-checkbox>
      <div *ngIf="formCopy.controls.synchro.value === true" class="alert alert-info-xs">
        {{ 'COPY_RECIPES.MODAL.WARN_SYNC_VAR' | translate }}
      </div>
    </div>
    <div class="space-t-m">
      <mat-checkbox class="space-h-s" id="RecipesModifyCopyTranslateChkBox" formControlName="translationRequested">{{
        'COPY_RECIPES.MODAL.TRAD_VAR' | translate
      }}</mat-checkbox>
    </div>
  </form>

  <div mat-dialog-actions>
    <button class="space-h-s btn-warn" id="RecipesModifyCopyCancelBtn" mat-raised-button (click)="cancel()">
      {{ 'CANCEL' | translate }}
    </button>
    <button class="space-h-s btn-submit" id="RecipesModifyCopyCopyBtn" mat-raised-button (click)="submit()" [disabled]="formCopy.invalid">
      {{ 'COPY_RECIPES.MODAL.BTN_COPY' | translate }}
    </button>
  </div>
</div>
